import { ExporttocsvService, csvDate } from '../../../../services/exporttocsv/exporttocsv.service';
import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {TransactionsService} from '../../../../services/transactions/transactions.service';
import {TeamsService} from '../../../../services/teams/teams.service';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {PaymentReportInterface} from './payment-report.interface';

@Component({
    selector: 'app-analytics-payment-report',
    templateUrl: './analytics-payment-report.component.html',
    styleUrls: ['./analytics-payment-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsPaymentReportComponent implements OnInit {
  @ViewChild(MatSort) sort!: MatSort;
  private teamId = '';
  public paymentsList: MatTableDataSource<PaymentReportInterface> = new MatTableDataSource<PaymentReportInterface>([]);
  public columnsToDisplay: string[] = ['userName', 'userId', 'yearMonth', 'allowanceSpent', 'transactions', 'allowanceBalance', 'wallitBalance'];


  exportCsv(title: string): void {
    this.csvExport.exportTable(title, this.paymentsList, {
      "userName": {header: "User Name", value: (item: any) => item.userName || '---'},
      "userId": {header: "User ID", value: (item: any) => item.userId || '---'},
      "yearMonth": {header: "Month", value: (item: any) => (csvDate(item.yearMonth, 'MMMM')) || '---'},
      "allowanceSpent": {header: "Monthly Allowance+Rewards Spent ($)", value: (item: any) => item.allowanceSpent || '---'},
      "transactions": {header: "Monthly Reimbursements Transactions (#)", value: (item: any) => item.transactions || 0},
      "allowanceBalance": {header: "Allowance Balance ($)", value: (item: any) => item.allowanceBalance || '---'},
      "wallitBalance": {header: "Wallit Balance ($)", value: (item: any) => item.wallitBalance || '---'},
    }, this.columnsToDisplay, {exclude: ['action', 'actionmenu']});
  }

  constructor(
      private transactionService: TransactionsService,
      private teamService: TeamsService,
      private csvExport: ExporttocsvService
  ) {}

  ngOnInit(): void {
    this.teamService.wellspaceChangedObservable.subscribe((team: any): void => {
      if (team && team.id) {
        this.teamId = team.id;
        this.getPaymentReportList();
      }
    });
  }

  getPaymentReportList(): any {
    if (this.teamId) {
      this.paymentsList.data = [];
      this.transactionService.getTeamPaymentReport(this.teamId).then((paymentReportList: PaymentReportInterface[]): void => {
        this.paymentsList.data = paymentReportList;
        this.paymentsList.sort = this.sort;
      }).catch(err => {
        this.paymentsList.data = [];
        console.error('Error in get payment report', err);
      });
    }
  }

}
